// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

function decodeUnprocessedError(json) {
  return /* DefaultError */{
          _0: {
            title: {
              TAG: /* UnprocessedEntity */1,
              _0: Json_decode.optional((function (param) {
                      return Json_decode.field("type", Json_decode.string, param);
                    }), json)
            },
            message: Json_decode.field("message", Json_decode.string, json)
          }
        };
}

function execute(data) {
  if (typeof data === "number" || data.TAG !== /* UnprocessedEntity */2) {
    return ResponseHandler$Catalyst.DefaultErrorConverter.execute(data);
  } else {
    return decodeUnprocessedError(data._0);
  }
}

export {
  decodeUnprocessedError ,
  execute ,
  
}
/* ResponseHandler-Catalyst Not a pure module */
